import { PopUpWrapperCSSStyle } from './popupwrappercss';
import * as React from 'react';
import { UIComponentViewImpl } from '../../toolkit/uicomponentview';
import { UIDataModel } from '../../toolkit/uicomponent';
import { PopUpWrapperComponentProps, PopUpWrapperComponentState } from './popupwrappercomponent';
import './popupwrappercss.css';

export class PopUpWrapperViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: PopUpWrapperComponentProps, state: PopUpWrapperComponentState, cssStyle: PopUpWrapperCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
    
        if(state.isShowWindow)
        {
            return (
                <>
                  <div id="popup-web">
                        {
                            this.getWebView(props, state, cssStyle)
                        }
                  </div>
                  {/* <div id="popup-mobile">
                      {
                          this.getMobileView(props, state, cssStyle)
                      }
                  </div> */}
                </>);
        }
       else{
           return false;
       }
    }

    getWebView(props: PopUpWrapperComponentProps, state: PopUpWrapperComponentState, cssStyle: PopUpWrapperCSSStyle):JSX.Element
    {
        return(
                <>
                    <div id="nodeA" style={cssStyle.getWrapperCSSStyle()}>
                     <div id="animatetop">
                        <div id="popup-content" style={cssStyle.getContentDivCSSStyle()}>
                            {
                                state.childComponent
                            }
                        </div>
                    </div>   
                    
                 </div>
                </>
        );
    }

    getMobileView(props: PopUpWrapperComponentProps, state: PopUpWrapperComponentState, cssStyle: PopUpWrapperCSSStyle):JSX.Element
    {
        return(
            <>
                 <div id="nodeA" style={cssStyle.getWrapperCSSStyle()}>
                    <div id="animatetop" style={cssStyle.getMobileContentDivCSSStyle()}>
                        {
                            state.childComponent
                        }
                    </div>
                 </div>
            </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/popupwrapperview.tsx